import { CodedProperty, NamedProperty, ResolutionProperty } from "sprint-common-web";

import {
    resolveOrderContentTitle,
    resolveOrderContentVersion
} from "../../../../../common/api/orders-api/order/ContentReference";
import { ProjectedOrderResponseItem } from "../../../../../common/api/orders-api/order/ValidateOrdersFromImportResponse";
import { EncodeSpecification } from "../../../../../common/types/EncodeSpecification";
import { OrderAssetAvailability } from "../../../../common/types/OrderAssetAvailability";
import { calculateOrderProgress, OrderProgressData } from "../../../../common/utils/calculateOrderProgress";

interface CloudAssetsVideoItem {
    targetFilename: string;
    availability: OrderAssetAvailability;
    targetResolution?: ResolutionProperty;
    sourceResolution?: ResolutionProperty;
    nonMatchingVideos: CloudAssetsNonMatchingVideoItem[];
}

interface CloudAssetsNonMatchingVideoItem {
    aspectRatio: NamedProperty;
    resolution: ResolutionProperty;
    subtitle: CodedProperty;
    assetId: string;
}

interface CloudAssetsSoundtrackItem {
    language: CodedProperty;
    availability: OrderAssetAvailability;
}

interface CloudAssetsSubtitleItem {
    language: CodedProperty;
    availability: OrderAssetAvailability;
    isEmbedded: boolean;
    targetFilename?: string;
}
interface CloudAssetsVideoItem {
    targetFilename: string;
    availability: OrderAssetAvailability;
    targetResolution?: ResolutionProperty;
    sourceResolution?: ResolutionProperty;
    nonMatchingVideos: CloudAssetsNonMatchingVideoItem[];
}

interface CloudAssetsNonMatchingVideoItem {
    aspectRatio: NamedProperty;
    resolution: ResolutionProperty;
    subtitle: CodedProperty;
    assetId: string;
}

interface CloudAssetsSoundtrackItem {
    language: CodedProperty;
    availability: OrderAssetAvailability;
}

interface CloudAssetsSubtitleItem {
    language: CodedProperty;
    availability: OrderAssetAvailability;
    isEmbedded: boolean;
    targetFilename?: string;
}

export interface ProjectedOrderItem {
    id: string;
    pONumber: string;
    airline: CodedProperty;
    system: NamedProperty;
    startDate: string;
    dueDate: string;
    content: string;
    version: string;
    video: CloudAssetsVideoItem;
    soundtracks: CloudAssetsSoundtrackItem[];
    subtitles: CloudAssetsSubtitleItem[];
    progress: OrderProgressData;
    targetFilenames: string[];
    encodeSpecification: EncodeSpecification;
    deliveryFolder: string;
}

export const mapToProjectedOrderItems = ({
    projectedOrders
}: {
    projectedOrders: ProjectedOrderResponseItem[];
}): ProjectedOrderItem[] => {
    return projectedOrders.map((projectedOrder, index) => ({
        id: `${projectedOrder.pONumber}-${index}`,
        pONumber: projectedOrder.pONumber,
        airline: projectedOrder.airline,
        system: projectedOrder.system,
        startDate: projectedOrder.startDate,
        dueDate: projectedOrder.dueDate,
        content: resolveOrderContentTitle(projectedOrder.content),
        version: resolveOrderContentVersion(projectedOrder.content),
        video: {
            targetFilename: projectedOrder.cloudAssets.video.targetFilename,
            availability: projectedOrder.cloudAssets.video.availability,
            targetResolution: projectedOrder.cloudAssets.video.targetResolution,
            sourceResolution: projectedOrder.cloudAssets.video.sourceResolution,
            nonMatchingVideos: projectedOrder.cloudAssets.video.nonMatchingVideos.map((video) => ({
                aspectRatio: video.aspectRatio,
                resolution: video.resolution,
                subtitle: video.subtitle,
                assetId: video.assetId
            }))
        },
        soundtracks: projectedOrder.cloudAssets.soundtracks.map((soundtrack) => ({
            availability: soundtrack.availability,
            language: soundtrack.language
        })),
        subtitles: projectedOrder.cloudAssets.subtitles.map((subtitle) => ({
            availability: subtitle.availability,
            language: subtitle.language,
            isEmbedded: subtitle.isEmbedded,
            targetFilename: subtitle.targetFilename
        })),
        progress: calculateOrderProgress(
            projectedOrder.cloudAssets.video.availability,
            projectedOrder.cloudAssets.soundtracks.map((soundtrack) => soundtrack.availability),
            projectedOrder.cloudAssets.subtitles.map((subtitle) => subtitle.availability)
        ),
        targetFilenames: [projectedOrder.cloudAssets.video.targetFilename],
        encodeSpecification: projectedOrder.encodeSpecification,
        deliveryFolder: projectedOrder.deliveryFolder
    }));
};
